"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_missing_1 = require("../any/is-missing");
/*
 * Checks if there is an array present
 *
 * @Example
 *
 *   isPresent([1, 2, 3])
 *   //=> true
 *
 *   isPresent([])
 *   //=> false
 *
 *   isPresent(null)
 *   //=> false
 *
 *   isPresent(undefined)
 *   //=> false
 */
function isPresent(array) {
    return !is_missing_1.isMissing(array) && array.length > 0;
}
exports.isPresent = isPresent;
//# sourceMappingURL=is-present.js.map